import { BaseViewModel } from "./base.viewmodel";

export class TopNavViewmodel extends BaseViewModel {
    override PageTitle: string = 'Top-Nav';
    toggleClass = true;
}

